import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {CartService} from "../../core/services/cart.service";
import {CommonService} from "../../core/services/common.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  cart: any[] = [];
  currentYear = (new Date()).getFullYear()
  selectedMenu: string = '/';
  authPanel: boolean = false;
  constructor(private router: Router, public cartService: CartService, private common: CommonService) {
    this.cartService.cart$.subscribe(cart => {
      this.cart = cart;
    });
  }

  makeActive(menu: string): void {
    this.selectedMenu = menu;
    if (!menu) menu = "/"
    this.router.navigateByUrl(menu);
  }

  checkAuth() {
    if (this.common.isLoggedIn()) this.makeActive('/user/profile');
    else this.authPanel = !this.authPanel;
  }
}
